import styled from "styled-components";
import { Text, } from "@bracket/ui/components";
import { Box, FlexBox, FlexStream, } from "@bracket/ui/nodes";
import { getTheme, } from "@bracket/ui/themes";
import type { ReactNode, } from "react";
import type { FlexAlignment, } from "@bracket/ui/types";

export declare type RasaTableCellProps = {
	label: string;
	value: string;
	basisPx?: number;
	grow?: number;
	align?: FlexAlignment;
	justify?: FlexAlignment;
	children: ReactNode;
	width?: string;
};


export const RasaTableCell = ({
	label,
	value,
	basisPx,
	grow,
	width,	
	align = "center",
	justify = "center",
	children, }: RasaTableCellProps) => {

	return (
		<RasaTableCellFrame $basisPx={basisPx} $grow={grow} $justify={justify} $align={align} $width={width} $debug>
			<ValueBox>{children}</ValueBox>
		</RasaTableCellFrame>
	);
};

const LabelBox = styled(FlexBox)`
	align-items: center;
	justify-content: flex-end;
	max-width: 40%;

`;

const ValueBox = styled(FlexBox)`
	align-items: center;
	max-width: 60%;
`;

const RasaTableCellFrame = styled(FlexBox)<{ $basisPx?: number; $grow?: number; $justify: FlexAlignment; $align?: FlexAlignment; $width?: string; }>`
	background: red!important;
	min-width: ${({ $width }) => $width};
`;
